import { render, staticRenderFns } from "./ImgFallback.vue?vue&type=template&id=e9f6efe4&"
import script from "./ImgFallback.vue?vue&type=script&lang=js&"
export * from "./ImgFallback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e9f6efe4')) {
      api.createRecord('e9f6efe4', component.options)
    } else {
      api.reload('e9f6efe4', component.options)
    }
    module.hot.accept("./ImgFallback.vue?vue&type=template&id=e9f6efe4&", function () {
      api.rerender('e9f6efe4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2OGElLc8UJBoP/JS/comp/ImgFallback.vue"
export default component.exports